import { render, staticRenderFns } from "./LaTable.vue?vue&type=template&id=2970c72e&scoped=true&"
import script from "./LaTable.vue?vue&type=script&lang=js&"
export * from "./LaTable.vue?vue&type=script&lang=js&"
import style0 from "./LaTable.vue?vue&type=style&index=0&id=2970c72e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2970c72e",
  null
  
)

export default component.exports